import { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  upsertUsers,
  type UserDirectoryUpsert,
} from "../app/userDirectory/userDirectorySlice";

/**
 * messages / comments / receivers / downloaded_users / memberships などから
 * 抽出したユーザー情報を Redux の userDirectory に一括 upsert するフック。
 *
 * 呼び出し側は `extractUsers` 関数で、最新のソースデータからユーザーリストを
 * 取り出して渡すのが慣例。`sourceKey` の変化を検知して不要な dispatch を抑制する
 * ことを期待しているので、useMemo 等で stable な配列を渡すことが望ましい。
 */
export const useSyncUserDirectory = (
  users: UserDirectoryUpsert[] | null | undefined,
): void => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!users || users.length === 0) return;
    dispatch(upsertUsers(users));
  }, [dispatch, users]);
};
